import styled from 'styled-components';

export const HelpPopUpStyled = styled.div`
  .modal-window {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.7);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1300;
    opacity: 1;
    transition: all 0.3s;
  }

  .modal-window > div {
    width: 100%;
    max-width: 100%;
    position: absolute;
    bottom: 0;
    left: 50%;
    padding: 37px 47px 38px;
    background: white;
    box-shadow: 0px -6px 84px rgba(0, 0, 0, 0.25);
    transform: translate(-50%, 0%);
    box-sizing: border-box;
    z-index: 1301;
  }

  .modal-close {
    position: absolute;
    right: 20px;
    text-align: center;
    top: -60px;
    text-decoration: none;
    z-index: 1301;
    cursor: pointer;
  }
  .modal_title {
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    color: ${(props) => props.theme.text.dark};
    margin-bottom: 8px;
  }
  .modal_subtitle {
    font-size: 15px;
    line-height: 18px;
    color: ${(props) => props.theme.text.medium};
    margin-right: 70px;
    font-weight: 600;
  }

  .contact_links {
    a {
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      color: ${(props) => props.theme.blue.dark};
      text-decoration: none;
      align-items: center;
      display: inline-flex;
      margin-right: 70px;
      white-space: nowrap;
      cursor: pointer;
      font-weight: 600;

      &:hover {
        color: ${(props) => props.theme.blue.dark};
      }
    }

    .innerText {
      display: inline-flex;
      align-items: center;
      font-weight: 600;
    }
  }

  .contactNum {
    color: black;
  }
  .contact_email {
    a {
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      text-decoration: none;
      align-items: center;
      display: inline-flex;
      margin-right: 70px;
      white-space: nowrap;
      cursor: pointer;
      font-weight: 600;

      &:hover {
        color: ${(props) => props.theme.blue.dark};
      }
    }

    .innerText {
      display: inline-flex;
      align-items: center;
      font-weight: 600;
    }
  }

  @media (max-width: 1065px) {
    .modal_subtitle {
      margin-bottom: 15px;
    }
  }
  @media (max-width: 490px) {
    .modal_subtitle {
      margin-right: 0;
    }
    .contact_links {
      a {
        margin-bottom: 10px;
      }
    }
  }
`;
